// extracted by mini-css-extract-plugin
export default {"container":"vD-z","dimension":"wD-z","dimensionLabels":"xD-z"};